import FloatingDraggedElement from "@builder/components/app/OliverBuildFrame/DnD/FloatingDraggedElement.js";
import PreviewLine from "@builder/components/app/OliverBuildFrame/DnD/PreviewLine.js";
import SnackbarNotification from "@builder/components/general/SnackbarNotification/index.js";
import loadFonts from "@builder/fonts/loadFonts.js";
import useGlobalHotkeys from "@builder/hooks/useGlobalHotkeys.js";
import React, { useEffect } from "react";
import "./App.scss";
import OliverHeader from "./components/app/OliverHeader";
import OliverMain from "./components/app/OliverMain";
import Popup from "./components/app/Popup";
import usePreventZoom from "./hooks/usePreventZoom.js";
import useSystemUI from "./hooks/useSystemUI.js";
import "./utils/lokalize.js";
import Onboard from "./components/onboard/Onboard";
import useWindowSize from "./hooks/useWindowSize.js";
import OnboardComplete from "./components/app/Popup/popups/OnboardComplete/OnboardComplete";

const App: React.FC = () => {
    useSystemUI();
    useGlobalHotkeys();
    usePreventZoom();
    const { isMobile } = useWindowSize();
    useEffect(() => {
        loadFonts();
    }, []);

    if (isMobile) {
        return (
            <div className="builder-app">
                <OnboardComplete />
                <Onboard />
                <SnackbarNotification />
            </div>
        );
    }

    return (
        <div className="builder-app">
            <OliverHeader />
            <OliverMain />
            <Popup />
            <Onboard />
            <SnackbarNotification />
            <PreviewLine />
            <FloatingDraggedElement />
        </div>
    );
};

export default App;
